import React, { useEffect, useMemo, useState, useContext } from 'react';
import { Context } from '../../../context/UserContext';

import moment from 'moment';

import { useDispatch } from 'react-redux';
import { selectComponent, clearSelectedComponent } from '../../../store/reducers/actions';

import { useNavigateParams } from '../../../hooks/useNavigateParams';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { Box, Button, IconButton, Tooltip, Checkbox } from '@mui/material';
import { Delete, Edit, ContentCopy, MonetizationOn } from '@mui/icons-material';
import PrintIcon from '@mui/icons-material/Print';
import Groups2Icon from '@mui/icons-material/Groups2';

import CustomDialog from '../../layout/CustomDialog';
import tratar from '../../../utils/retornaTratamentoURL';
import * as EmpresaAPI from '../../../api/empresa';
import * as TabelaAPI from '../../../api/tabela';

import CrudsAPI from '../../../api/CRUDs';
import { recebeAnoMesRetornaPorExtenso } from '../../../utils/retornaDataFormatada';

import { relatorios } from '../../../api/relatorios';

/* util */
import { obterPermissoesUsuario, resolveEmpresaTabela, printPdf } from '../../../utils/funcoes';
import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { obterInicioEFimDoMes } from '../../../utils/financeiro';
import { useMRTState } from '../../../hooks/useMRTState';
import {
    podeEditar,
    podeImprimir,
    podeIncluir,
    podeCancelar,
    podeImprimirAnalitico,
    podeImprimirGerencia,
    podeImprimirSintetico,
} from '../../../hooks/usePermisionMRT';

const Index = () => {
    const [dados, setDados] = useState([]);
    const [token] = useState(localStorage.getItem('token')) || '';
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const { parametro } = useContext(Context);
    const { pessoaId, empresaId, empresaIds } = getEmpresaScope();
    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);

    const pathname = '/CentroCustoLimites';
    const ul = urlParams.get('ul') || 3;
    const li = urlParams.get('li') || 37;
    const tipo = urlParams.get('tipo') || 'Pagar';
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || 'Cadastrar';

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //para alimentar o dataPicker
    const hoje = new Date();
    const { primeiroDia } = obterInicioEFimDoMes(hoje);

    const mrt = useMRTState({
        storageKey: `centroCustoLimites:${tipo || 'default'}`,
        initialState: {
            columnFilterFns: {
                'Empresa.nomeFantasia': 'equals',
                'centroCusto.descricao': 'equals',
                mes: 'equals',
                ativo: 'equals',
            },
            columnFilters: [{ id: 'mes', value: primeiroDia }],
            globalFilter: '',
            sorting: [],
            pagination: {
                pageIndex: 0,
                pageSize: parametro?.paginacao || 10,
            },
        },
    });

    //options
    const [optionsCentroCustos, setCC] = useState([]);
    const [optionsEmpresa, setEmpresa] = useState([]);
    const [optionsGrupo, setGrupo] = useState([]);

    //dialog customizado
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    //duplicar varios
    const dispatch = useDispatch();

    const [isDisabledPrint, setIsDisabledPrint] = useState(true);

    //atualizar a grid
    const fetchData = async () => {
        if (!dados.length) {
            mrt.setIsLoading(true);
        } else {
            mrt.setIsRefetching(true);
        }

        try {
            CrudsAPI.centroCustoLimite
                .listar(
                    mrt.pagination.pageIndex * mrt.pagination.pageSize,
                    mrt.pagination.pageSize,
                    JSON.stringify(mrt.columnFilters ?? []),
                    JSON.stringify(mrt.columnFilterFns ?? []),
                    mrt.globalFilter ?? '',
                    JSON.stringify(mrt.sorting ?? [])
                )
                .then((response) => {
                    if (response.status === 202) {
                        setFlashMessage(response.data.message, response.data.type);
                        setIsDisabledPrint(true);
                        setDados([]);
                        mrt.setRowCount(0);
                        return;
                    } else {
                        setIsDisabledPrint(false);
                    }

                    setDados(response.data.data);
                    mrt.setRowCount(response.data.meta.totalRowCount);
                });
        } catch (error) {
            mrt.setIsError(true);
            console.error(error);
            return;
        }
        mrt.setIsError(false);
        mrt.setIsLoading(false);
        mrt.setIsRefetching(false);
    };
    const consultaCC = async () => {
        const result = await EmpresaAPI.centroCustos(dados.empresaId, null, tipo, null, null, null);
        // Mapear o array para extrair apenas 'id' e 'descricao'
        const mappedResult = result.map((item) => ({
            value: item.descricao,
            label: item.descricao,
        }));

        setCC(mappedResult);
    };

    //carregar API's Externas
    //retorna um array de empresas
    const consultaEmpresa = async () => {
        const result = await EmpresaAPI.empresa(empresaId);

        // Extrai apenas os campos desejados
        const mappedResult = result.map((emp) => ({
            value: emp.nomeFantasia,
            label: emp.nomeFantasia,
        }));

        setEmpresa(mappedResult);
    };
    //retorna um array de qualquer tabela
    const consultaTabela = async (empresaId, tabela) => {
        if (!tabela) return;
        const result = await TabelaAPI.tabela(empresaId, tabela, 'descricao');

        // Extrai apenas os campos desejados
        const mappedResult = result.map((emp) => ({
            value: emp.descricao,
            label: emp.descricao,
        }));

        if (tabela === 'Grupo') {
            setGrupo(mappedResult);
        } else {
            return [];
        }
    };

    //funções do dialog
    const handleOpenDialog = (row) => {
        setOpenDialog(true);
        setSelectedRow(row);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDialog = async (row) => {
        // Verifique se há uma linha selecionada
        let msgType = 'success';
        if (selectedRow) {
            try {
                const response = await CrudsAPI.centroCustoLimite.deletar(selectedRow);

                setFlashMessage(response.data.message, msgType);

                // Após a exclusão, chame a função fetchData() novamente para atualizar as unidades
                fetchData();
            } catch (error) {
                msgType = 'error';
                console.error(error);
                setFlashMessage(error.response.data.message, msgType);
            }
        }
        setOpenDialog(false);
    };

    useEffect(() => {
        if (!token) {
            navigate('/Auth', { replace: true });
        }
    }, [token, navigate]);

    useEffect(() => {
        const temFiltroMes = mrt.columnFilters?.some((f) => f.id === 'mes');

        if (!temFiltroMes) {
            mrt.setColumnFilters((prev) => [...(prev || []), { id: 'mes', value: primeiroDia }]);
        }
    }, [mrt.columnFilters, mrt.setColumnFilters, primeiroDia]);
    useEffect(() => {
        //permissões do usuario
        obterPermissoesUsuario(pessoaId, empresaId, ul, li);

        consultaCC();
        consultaEmpresa();
        consultaTabela(empresaId, 'Grupo');
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mrt.columnFilterFns,
        mrt.columnFilters,
        mrt.globalFilter,
        mrt.pagination.pageIndex,
        mrt.pagination.pageSize,
        mrt.sorting,
        tipo,
    ]);

    const columns = useMemo(
        //column definitions...
        () => [
            {
                id: 'CentroCusto',
                header: 'Limite de Centros de Custos',
                columns: [
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.ativo;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'Empresa.nomeFantasia',
                        header: 'Empresa',
                        filterVariant: 'select',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: optionsEmpresa,
                    },
                    {
                        accessorKey: 'centroCusto.Grupo.descricao',
                        header: 'Grupo',
                        filterVariant: 'select',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: optionsGrupo,
                    },
                    {
                        accessorKey: 'centroCusto.descricao',
                        header: 'Centro de Custo',
                        filterVariant: 'select',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: optionsCentroCustos,
                    },
                    {
                        accessorKey: 'mes',
                        header: 'Mês',
                        filterVariant: 'date',
                        sortingFn: 'date',
                        columnFilterModeOptions: ['equals'],
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'left',
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                        muiFilterTextFieldProps: {
                            sx: {
                                minWidth: '250px',
                            },
                        },
                        Cell: ({ renderedCellValue, row }) => {
                            const formatoDesejado = recebeAnoMesRetornaPorExtenso(row.original.mes);
                            return <span>{formatoDesejado}</span>;
                        },
                    },
                    {
                        accessorKey: 'limite',
                        header: 'Limite',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        accessorFn: (row) =>
                            row.limite === null
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.limite)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'lancadoMes',
                        header: 'Lançado no Mês',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        accessorFn: (row) =>
                            row.lancadoMes === null
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.lancadoMes)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'debito',
                        header: 'Atrasado',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        columnFilterModeOptions: [],
                        accessorFn: (row) =>
                            row.debito === null
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.debito)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'aberto',
                        header: 'Aberto',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        columnFilterModeOptions: [],
                        accessorFn: (row) =>
                            row.aberto === null
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.aberto)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'baixado',
                        header: 'Baixado',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        columnFilterModeOptions: [],
                        accessorFn: (row) =>
                            row.baixado === null
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.baixado)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'meta',
                        header: 'Meta',
                        muiTableBodyCellProps: {
                            align: 'right',
                        },
                        columnFilterModeOptions: [],
                        accessorFn: (row) =>
                            row.meta === null
                                ? ''
                                : parseFloat(row.meta)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }) + ' %',
                    },
                ],
            },
        ],
        [optionsCentroCustos, optionsEmpresa, optionsGrupo] //getCommonEditTextFieldProps
    );
    /* modo tema */
    const theme = tableThemeCustom();

    return (
        <div>
            <div>
                {openDialog && (
                    <CustomDialog
                        title="Delete limite de CENTRO DE CUSTO!"
                        content="Você tem certeza?"
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                    />
                )}
            </div>
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-select': {
                            enableColumnActions: true,
                            enableHiding: true,
                            size: 50,
                        },
                        'mrt-row-actions': {
                            muiTableHeadCellProps: {
                                align: 'center',
                            },
                            size: 100,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row, table }) => {
                        const handleDuplicar = async () => {
                            params.set('uuid', row.id);
                            params.set('btnText', 'Duplicar');
                            navigate(pathname + '/CreateOrEdit', params);
                        };
                        return (
                            <div>
                                {' '}
                                <Box sx={{ display: 'flex', gap: '1rem' }}>
                                    <Tooltip arrow placement="left" title="Editar">
                                        <span>
                                            {' '}
                                            <IconButton
                                                onClick={() => {
                                                    params.set('uuid', row.id);
                                                    params.set('btnText', 'Atualizar');
                                                    navigate(pathname + '/CreateOrEdit', params);
                                                }}
                                                disabled={!podeEditar()}
                                            >
                                                <Edit />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip arrow placement="right" title="Deletar">
                                        <span>
                                            <IconButton
                                                color="error"
                                                onClick={() => handleOpenDialog(row)}
                                                disabled={!podeCancelar()}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip arrow placement="right" title="Duplicar">
                                        <span>
                                            <IconButton
                                                color="error"
                                                onClick={() => handleDuplicar(row)}
                                                disabled={!podeIncluir()}
                                            >
                                                <ContentCopy />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                            </div>
                        );
                    }}
                    renderTopToolbarCustomActions={({ table }) => {
                        const handleDuplicarSelected = async () => {
                            dispatch(clearSelectedComponent()); // Limpa os valores selecionados
                            const uuids = table.getSelectedRowModel().flatRows.map((row) => row.id);

                            dispatch(selectComponent(uuids)); // Preenche com os novos valores

                            // Navega para a rota apenas se houver itens selecionados
                            if (uuids.length > 0) {
                                navigate(pathname + '/Duplicar', params);
                            }
                        };

                        //RELATORIO DE DESPESAS POR CENTRO DE CUSTO
                        const despesasAgrupadaByCentroCusto = async () => {
                            const mes = mrt.columnFilters.find((f) => f.id === 'mes');
                            const nomeFantasia = mrt.columnFilters.find((f) => f.id === 'Empresa.nomeFantasia');

                            const obj = {
                                mes: mes?.value,
                                nomeFantasia: nomeFantasia?.value,
                                empresaIds: empresaIds,
                            };

                            const response = await relatorios(
                                'despesasAgrupadaByCentroCusto',
                                'despesasAgrupadaByCentroCusto',
                                obj
                            );

                            //gera o pdf
                            printPdf(response.data);
                        };

                        const despesasAgrupadaByGrupoCentroCusto = async () => {
                            if (!dados[0]) {
                                setFlashMessage('Não existe registros suficiente para gerar o relatório', 'warning');
                                return;
                            }

                            const mes = mrt.columnFilters.find((f) => f.id === 'mes');
                            const nomeFantasia = mrt.columnFilters.find((f) => f.id === 'Empresa.nomeFantasia');

                            const obj = {
                                mes: mes?.value,
                                nomeFantasia: nomeFantasia?.value,
                                empresaIds: empresaIds,
                                outros: false, // junta os centros de custos que não possuem grupos definidos
                            };

                            const response = await relatorios(
                                'despesasAgrupadaByGrupoCentroCusto',
                                'despesasAgrupadaByGrupoCentroCusto',
                                obj
                            );

                            //gera o pdf
                            printPdf(response.data);
                        };

                        const conciliacaoEmpresasPagadoras = async () => {
                            const mes = mrt.columnFilters.find((f) => f.id === 'mes');
                            const nomeFantasia = mrt.columnFilters.find((f) => f.id === 'Empresa.nomeFantasia');
                            const centroCusto = mrt.columnFilters.find((f) => f.id === 'centroCusto.descricao');

                            const obj = {
                                mes: mes?.value,
                                nomeFantasia: nomeFantasia?.value,
                                empresaIds: empresaIds,
                                centroCustoDescricao: centroCusto?.value || '',
                            };

                            const response = await relatorios(
                                'conciliacaoEmpresasPagadorasCentroCusto',
                                'conciliacaoEmpresasPagadorasCentroCusto',
                                obj
                            );

                            //gera o pdf
                            printPdf(response.data);
                        };

                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '8px',
                                }}
                            >
                                <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                    <div>
                                        <Button
                                            color="secondary"
                                            onClick={() => {
                                                params.delete('uuid');
                                                params.set('btnText', 'Cadastrar');
                                                navigate(pathname + '/CreateOrEdit', params);
                                            }}
                                            variant="contained"
                                            disabled={!podeIncluir()}
                                        >
                                            Novo
                                        </Button>
                                    </div>
                                </Tooltip>
                                <Tooltip arrow placement="top-end" title={`Duplicar registros selecionados`}>
                                    <div>
                                        <Button
                                            color="success"
                                            onClick={
                                                !table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected()
                                                    ? null
                                                    : handleDuplicarSelected
                                            }
                                            variant="contained"
                                            disabled={
                                                !podeIncluir() ||
                                                (!table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected())
                                            }
                                        >
                                            Duplicar
                                        </Button>
                                    </div>
                                </Tooltip>
                                <Tooltip arrow placement="top-end" title={`Imprimir Acompanhamento Centro de Custo`}>
                                    <div>
                                        <span>
                                            <Button
                                                color="info"
                                                variant="contained"
                                                disabled={!podeImprimir || isDisabledPrint}
                                                onClick={() => despesasAgrupadaByCentroCusto()}
                                            >
                                                <PrintIcon />
                                                {' Imprimir'}
                                            </Button>
                                        </span>
                                    </div>
                                </Tooltip>
                                <Tooltip
                                    arrow
                                    placement="top-end"
                                    title={`Imprimir despesas por grupo de centros de custo no período`}
                                >
                                    <div>
                                        <span>
                                            <Button
                                                color="info"
                                                variant="contained"
                                                disabled={!podeImprimirSintetico()}
                                                onClick={() => despesasAgrupadaByGrupoCentroCusto()}
                                            >
                                                <Groups2Icon />
                                                {' Grupo'}
                                            </Button>
                                        </span>
                                    </div>
                                </Tooltip>
                                <Tooltip
                                    arrow
                                    placement="top-end"
                                    title={`Conciliação de empresas pagadoras por centro de custos das despesas no período`}
                                >
                                    <div>
                                        <span>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                disabled={!podeImprimirGerencia()}
                                                onClick={() => conciliacaoEmpresasPagadoras()}
                                            >
                                                <MonetizationOn />
                                                {' Conciliação'}
                                            </Button>
                                        </span>
                                    </div>
                                </Tooltip>
                            </div>
                        );
                    }}
                    columns={columns}
                    data={dados}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                        mrt.isError
                            ? {
                                  color: 'error',
                                  children: 'Error loading data',
                              }
                            : undefined
                    }
                    onColumnFiltersChange={mrt.setColumnFilters}
                    onColumnFilterFnsChange={mrt.setColumnFiltersMode}
                    onGlobalFilterChange={mrt.setGlobalFilter}
                    onPaginationChange={mrt.setPagination}
                    onSortingChange={mrt.setSorting}
                    rowCount={mrt.rowCount}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                        //columnPinning: { left: ["mrt-row-select"] },
                    }}
                    state={{
                        columnFilterFns: mrt.columnFilterFns,
                        columnFilters: mrt.columnFilters,
                        globalFilter: mrt.globalFilter,
                        isLoading: mrt.isLoading,
                        pagination: mrt.pagination,
                        showAlertBanner: mrt.isError,
                        showProgressBars: mrt.isRefetching,
                        sorting: mrt.sorting,
                    }}
                    //positionToolbarDropZone={"top"}
                    //positionExpandColumn={"last"}
                    positionActionsColumn={'first'}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};
export default Index;
